export default {
    meta: {
        title: '第三方sdk清单'
    }
};
